import { render, staticRenderFns } from "./txtPreview.vue?vue&type=template&id=faa83f40&scoped=true"
import script from "./txtPreview.vue?vue&type=script&lang=js"
export * from "./txtPreview.vue?vue&type=script&lang=js"
import style0 from "./txtPreview.vue?vue&type=style&index=0&id=faa83f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa83f40",
  null
  
)

export default component.exports